import React from "react";
import styled from "styled-components";

const Textarea = styled.textarea`
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  ::placeholder {
    color: ${({ theme }) => theme.text};
  }
  &:focus {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
  }
`;

export default Textarea;
